import RotatingLoadingText from "@/app/components/RotatingLoadingText";

/**
 * The breathe keyframes used to live in the MUI `keyframes` helper.
 * They are declared inline here rather than in `css/animations.css` so the
 * component stays self-contained; the name is prefixed to avoid collisions
 * since keyframe names are global.
 */
const breatheStyles = `
@keyframes lo-breathe {
	0%, 100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.05);
		opacity: 0.8;
	}
}
`;

export function BouncingLogo({ size = 150 }: { size?: number }) {
	return (
		<>
			{/* biome-ignore lint/security/noDangerouslySetInnerHtml: static keyframes, no user input */}
			<style dangerouslySetInnerHTML={{ __html: breatheStyles }} />
			<img
				src="/single_512x512.png"
				alt="Loading"
				style={{
					width: size,
					height: size,
					animation: "lo-breathe 1s ease-in-out infinite",
				}}
			/>
		</>
	);
}

export default function LoadingOverlayComponent({
	active,
	children,
	text,
}: any) {
	return (
		<div className="relative h-full w-full">
			{children}
			{active && (
				<div className="fixed top-0 left-0 z-[9999] flex h-screen w-screen flex-col items-center justify-center gap-4 bg-background/90">
					<BouncingLogo />
					{text ? (
						<p className="text-foreground text-base">{text}</p>
					) : (
						<RotatingLoadingText variant="body2" />
					)}
				</div>
			)}
		</div>
	);
}
